import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Footer from "./components/Footer";
import NotFound from "./components/NotFound";
import Products from "./components/Products";
import Aktdivision from "./components/Aktdivision";
import Enginering from "./components/Engine-&-Transmision";
import Aboutus from "./components/Aboutus";
import News from "./components/News";
import Compliance from "./components/Compliance";
import Contactus from "./components/Contactus";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsofService from "./components/TermsofService";
import Careers from "./components/Careers";
import CookiePolicy from "./components/CookiePolicy";
import Login from "./components/Login";
import Register from "./components/Section/Register";
import CookieHandler from "./CookieHandler";
import Automation from "./components/Automation";
import ExploreDivision from "./components/ExploreDivision";
import SuspensionDivision from "./components/Suspension-&-Brake";
import Automotivemetal from "./components/Automotive-Metal-Steet";
import SteelDivision from "./components/Steeldivision";
import Structsteel from "./components/StructSteel";
import Steelpipes from "./components/SteelPipes";
import Tire from "./components/Tirereinforcement";
import Production from "./components/Production";
import Dashboard from "./components/Dashboard";
import Support from "./components/Whatsapp";
import Listing from "./components/Section/Dashboard/Listing";
import UpdateListing from "./components/Section/Dashboard/UpdateListing";
import UpdateListingDaynamic from "./components/Section/Dashboard/DaynamicdataListing";
import DeleteListingDaynamic from "./components/Section/Dashboard/DaynamicdataDelete";
import DeleteListing from "./components/Section/Dashboard/DeleteListing";
import Addnews from "./components/Section/Dashboard/news";
import Addevents from "./components/Section/Dashboard/events";
import Updatenews from "./components/Section/Dashboard/Update-news";
import useAutoLogout from "./hooks/useAutoLogout";
import Deletenews from "./components/Section/Dashboard/DeleteNews";
import Updateevents from "./components/Section/Dashboard/Update-events";
import Deleteevents from "./components/Section/Dashboard/Delete-event";
import Addcompliance from "./components/Section/Dashboard/Update-Complance";
import Updatecompliance from "./components/Section/Dashboard/Updatess-comp";
import Deletecompliance from "./components/Section/Dashboard/Delete-complace";
import Selment from "./components/SEALENTS";
import Adhesives from "./components/ADHESIVES";
import Roofcoatings from "./components/ROOF-COATINGS";
import ViewPDF from "./components/ViewPDF";
import ViewPDFs from "./components/ViewPDFs";
import ViewPDFDOCs from "./components/ViedDocPDFs";
import Addpdf from "./components/Section/Dashboard/Pdf-Add";
import Editpdf from "./components/Section/Dashboard/Pdf-Edit";
import Deletepdf from "./components/Section/Dashboard/Pdf-Delete";
import Rtv from "./components/RTVmain";
import ProductDetails from "./components/ProductDetails";
import AddRelatedDocument from "./components/Section/Dashboard/Related-Document-add";
import EditRelatedDocument from "./components/Section/Dashboard/Related-Document-Edit";
import DeleteRelatedDocument from "./components/Section/Dashboard/Related-Document-delete";
import ScrollToTop from './ScrollToTop';
import Akttools from "./components/Akttools";
import CarWorks from "./components/Section/Carwashmain";
import Powercoating from "./components/Akt-Power-Coating";
import Valves from "./components/Valve&flanches";
import Quickservices from"./components/Aktquick";
import ProjectsCompleted from"./components/CompletedProjects";

const App = () => {
  
  return (
    <Router>
      <AutoLogoutWrapper />
      <div className="flex flex-col min-h-screen">
        {/* Wrapped Navbar with padding */}
        <div className="pt-20"> 
          <Navbar />
        </div>
        <ScrollToTop />
        {/* Main Content with Responsive Margins */}
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/business-segment" element={<Products />} />
            <Route path="/division" element={<Aktdivision />} />
            <Route path="/about-us" element={<Aboutus />} />
            <Route path="/media" element={<News />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/division/Selment" element={<Selment />} />
            <Route path="/division/Adhesives" element={<Adhesives />} />
            <Route path="/division/Roofcoating" element={<Roofcoatings />} />
            <Route path="/contact-us" element={<Contactus />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsofService />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/new-reg-admin" element={<Register />} />
            <Route path="/division/akt-car-wash" element={<Automation />} />
            <Route path="/division/akt-tools-division" element={<Akttools />} />
            <Route path="/division/akt-car-care" element={<CarWorks />} />
            <Route path="/division/engine-&-transmission" element={<Enginering />} />
            <Route path="/division/explore-divisions" element={<ExploreDivision/>} />
            <Route path="/division/suspension-&-brake-systems" element={<SuspensionDivision/>} />
            <Route path="/division/automotive-metal-steet" element={<Automotivemetal/>} />
            <Route path="/division/steel-divisions" element={<SteelDivision/>} />
            <Route path="/division/structural-divisions" element={<Structsteel/>} />
            <Route path="/division/project-completed" element={<ProjectsCompleted/>} />
            <Route path="/division/steel-pipes" element={<Steelpipes/>} />
            <Route path="/division/valve-&-flanges" element={<Valves/>} />
            <Route path="/division/akt-quick-services" element={<Quickservices/>} />
            <Route path="/division/powder-coating" element={<Powercoating/>} />
            <Route path="/division/tire-reinforcement" element={<Tire/>} />
            <Route path="/division/production" element={<Production/>} />
            <Route path="/cookie" element={<CookieHandler />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/listing" element={<Listing />} />
            <Route path="/update-listing" element={<UpdateListing />} />
            {/* <Route path="/update-listing-daynamic/:productId" element={<UpdateListingDaynamic />} /> */}
            <Route path="/update-listing-daynamic" element={<UpdateListingDaynamic />} />
            <Route path="/delete-listing-daynamic" element={<DeleteListingDaynamic />} />
            <Route path="/delete-listing" element={<DeleteListing />} />
            <Route path="/add-news" element={<Addnews />} />
            <Route path="/add-events" element={<Addevents />} />
             <Route path="/update-events" element={<Updateevents />} />
            <Route path="/delete-events" element={<Deleteevents />} />
            <Route path="/update-news" element={<Updatenews />} />
            <Route path="/delete-news" element={<Deletenews />} />
            <Route path="/add-compliance" element={<Addcompliance />} />
            <Route path="/update-compliance" element={<Updatecompliance />} />
            <Route path="/delete-compliance" element={<Deletecompliance />} />
            <Route path="/view-pdf/:id" element={<ViewPDF />} />
            <Route path="/view-pdfs/:id" element={<ViewPDFs />} />
            <Route path="/view-pdf-doc/:id" element={<ViewPDFDOCs />} />
            <Route path="/add-pdf" element={<Addpdf />} />
            <Route path="/related-document" element={<AddRelatedDocument />} />
            <Route path="/edit-related-document" element={<EditRelatedDocument />} />
            <Route path="/delete-related-document" element={<DeleteRelatedDocument />} />
            <Route path="/update-pdf" element={<Editpdf />} />
            <Route path="/delete-pdf" element={<Deletepdf />} />
            <Route path="/division/Rtv" element={<Rtv />} />
            <Route path="/product/:id" element={<ProductDetails />} />
            

          </Routes>
        </div>
        
        {/* Footer with Same Margins */}
        <div>
          <Support/>
          <Footer />
        </div>
      </div>
    </Router>
  );
};
// ✅ Move useAutoLogout inside a wrapper component
const AutoLogoutWrapper = () => {
  useAutoLogout(); 
  return null; // No UI needed, just runs the hook
};

export default App;
